import styled from "styled-components";
import { colorsPalettes } from "@similarweb/styles";
import { setFontVariant } from "@similarweb/styles";
import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const IconWrapper = styled(FlexRow)`
    align-content: center;
    justify-content: center;
    position: relative;
    width: 32px;
    height: 32px;
`;

const FloatingIconContainer = styled(FlexRow)`
    position: absolute;
    margin: 1px;
    border-radius: 3.75px;
    box-shadow: 0 3px 6px rgb(14 30 62 / 8%);

    & > * {
        margin: auto;
    }

    & span {
        border-color: ${colorsPalettes.midnight[50]};
        overflow: hidden;
        border-radius: 3.75px !important;
    }

    & img {
        width: 16px;
        height: 16px;
    }
`;

export const TopIconContainer = styled(FloatingIconContainer)`
    top: 0;
    left: 0;
`;

export const BottomIconContainer = styled(FloatingIconContainer)`
    bottom: 0;
    right: 0;
`;

export const ExtraItemsCountWrapper = styled.span`
    overflow: visible !important;

    & > div > div {
        width: 20px;
        border-radius: 3px;
        ${setFontVariant("caption", colorsPalettes.carbon[200])};
    }
`;
